import React, {Component} from 'react';

import {
    Row
} from "reactstrap";

import ListItem from "../../components/Vietluck/ListItem";

import {Link} from "react-router-dom";

const logo = {
    "vnpay": require("../../assets/images/icon/vnpay.png"),
    "bank": require("../../assets/images/icon/otherbank.png"),
    "momo": require("../../assets/images/icon/momo.png"),
    "viettel": require("../../assets/images/icon/viettelpay.png"),
    "zalo": require("../../assets/images/icon/zalopay.png"),
};

class Recharge extends Component {
    render() {
        return (
            <div className="p-2 bootstrap-reset">
                <Row className="mb-3">Vietluck hỗ trợ người chơi nạp tiền vào tài khoản thông qua các hình thức
                                      sau:</Row>
                                      <Link to={"/recharge-items#2"} className="link-unset">
                    <ListItem
                        avatar={logo["bank"]}
                        title="Chuyển tiền qua tài khoản ngân hàng"
                        subtitle={"Tự động - tối đa 5 phút"}
                    />
                </Link>  
               
                {/* <Link to={"/recharge-items#3"} className="link-unset">
                
                    <ListItem
                        avatar={logo["momo"]}
                        title="Nạp tiền qua Momo"
                        subtitle={"Tự động - tối đa 5 phút"}
                    />
                </Link> */}
                <Link to={"/recharge-items#1"} className="link-unset">
                    <ListItem
                        avatar={logo["vnpay"]}
                        title="Nạp tiền qua VNPAY"
                        subtitle={"Nhận tiền ngay"}
                    />
                </Link>  
              
            </div>
        );
    }
}

export default Recharge;
